import { ElMessage, type MessageOptions } from 'element-plus/es/components/message/index.mjs'
import 'element-plus/es/components/message/style/css'
import { ApiError, ErrorType } from '@/types/error'

type MessageContent = NonNullable<MessageOptions['message']>

/** 统一消息提示配置，避免各页面重复设置 Element Plus Message 行为 */
const baseMessageOptions = {
  duration: 3000,
  grouping: true,
} satisfies Partial<MessageOptions>

/** 全局消息提示方法集合 */
export const message = {
  /** 展示成功反馈 */
  success(content: MessageContent) {
    return ElMessage.success({ ...baseMessageOptions, message: content })
  },

  /** 展示错误反馈 */
  error(content: MessageContent) {
    return ElMessage.error({ ...baseMessageOptions, message: content })
  },

  /** 展示警告反馈 */
  warning(content: MessageContent) {
    return ElMessage.warning({ ...baseMessageOptions, message: content })
  },

  /** 展示普通信息反馈 */
  info(content: MessageContent) {
    return ElMessage.info({ ...baseMessageOptions, message: content })
  },
}

/**
 * 从接口异常中提取适合展示给用户的提示文案。
 * @param error 接口调用抛出的异常对象，可为 ApiError 或其他 Error
 * @param fallback 当异常对象中没有可用 message 时展示的兜底文案
 * @returns 优先返回异常 message，否则返回兜底文案
 */
export function getFeedbackMessage(error: unknown, fallback: string): string {
  return error instanceof Error && error.message ? error.message : fallback
}

/**
 * 统一展示接口异常提示：优先展示后端 message，无则用兜底文案。
 * 请求被主动取消（去重取消旧请求等）时不弹提示，避免打扰用户。
 * @param error 接口调用抛出的异常对象
 * @param fallback 无可用后端 message 时展示的兜底文案
 */
export function showApiError(error: unknown, fallback: string): void {
  // 请求取消属于正常流程，不向用户弹错误提示
  if (error instanceof ApiError && error.type === ErrorType.CANCEL_ERROR) return
  message.error(getFeedbackMessage(error, fallback))
}
